import { useEffect, useState } from "react";

import {
  Loader,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Notification,
  NotificationType,
} from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { useTrekSettings } from "./api";
import {
  AdvisorRoleDropdown,
  MSADropdown,
  SecureModeToggle,
} from "./components";

import "./trek-mobile-settings.modal.scss";

export const TrekMobileSettingsModal = ({ open, onClose, organization }) => {
  const [notification, setNotification] = useState();
  const {
    settings,
    applyChanges,
    update,
    fetchingSettings,
    applyingChanges,
    errorFetchingSettings,
    errorApplyingChanges,
    successApplyingChanges,
    settingsChanged,
  } = useTrekSettings({ organizationCode: organization?.code, enabled: open });

  const onSaveChanges = async () => {
    await applyChanges();
  };

  const onCloseHandler = () => {
    setNotification();
    onClose();
  };

  useEffect(() => {
    if (errorFetchingSettings || errorApplyingChanges) {
      setNotification({
        type: NotificationType.error,
        message: "There was an error. Please try again.",
        closable: true,
        onClose: () => setNotification(),
      });
    }
  }, [errorFetchingSettings, errorApplyingChanges]);

  useEffect(() => {
    if (successApplyingChanges) {
      setNotification({
        type: NotificationType.success,
        message: "Settings updated successfully.",
        closable: true,
        onClose: () => setNotification(),
      });
    }
  }, [successApplyingChanges]);

  return (
    <Modal
      modalClassName="trek-mobile-settings-modal"
      open={open}
      onClose={onCloseHandler}
      preventClose={applyingChanges}
    >
      <ModalHeader title="Trek Mobile Settings" label={organization?.name} />
      <ModalBody>
        {applyingChanges && <Loader overlay fixed />}
        {notification && (
          <Notification {...notification}>{notification.message}</Notification>
        )}
        <div className="trek-mobile-settings-field">
          <h2>Location</h2>
          <MSADropdown
            selected={settings?.msa}
            onChange={(msa) => update("msa", msa)}
            loading={fetchingSettings}
          />
        </div>
        <div className="trek-mobile-settings-field">
          <h2>Advisor Role</h2>
          <AdvisorRoleDropdown
            selected={settings?.advisorRole}
            onChange={(role) => update("advisorRole", role)}
            loading={fetchingSettings}
          />
        </div>
        <div className="trek-mobile-settings-field">
          <h2>Secure Mode</h2>
          <SecureModeToggle
            value={settings?.secureMode ?? false}
            onChange={(secureMode) => update("secureMode", secureMode)}
            loading={fetchingSettings}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onCloseHandler} disabled={applyingChanges}>
          Cancel
        </Button>
        <Button
          primary
          onClick={onSaveChanges}
          disabled={applyingChanges || !settingsChanged}
        >
          Apply
        </Button>
      </ModalFooter>
    </Modal>
  );
};
